export default {
  company: []
}
